<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="noind" id="epigraph"><a id="start">I did not know then how much was ended. When I look back now... I can still see the butchered women and children lying heaped and scattered all along the crooked gulch as plain as when I saw them with eyes still young. And I can see that something else died there in the bloody mud, and was buried in the blizzard. A people’s dream died there. It was a beautiful dream ... the nation’s hoop is broken and scattered. There is no center any longer, and the sacred tree is dead.</a></p><a id="start">
<p class="right"><span><i>—BLACK ELK, Black Elk Speaks</i></span></p>
</a></blockquote><a id="start">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?e812f7ea